
import { Header } from "@/components/Header";
import Footer from "@/components/Footer";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-24 pb-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
          
          <div className="space-y-6 text-gray-700">
            <div className="mb-4">
              <p className="text-sm mb-2">
                Effective Date: 8/02/2025<br />
                Last Updated: 08/02/2025
              </p>
              <p className="mb-4">
                DubCity AI Solutions values your privacy and is committed to protecting your personal information. 
                This policy outlines how we collect, use, and safeguard the data of our clients, users, and visitors.
              </p>
            </div>

            <section>
              <h2 className="text-xl font-semibold mb-3">1. Information We Collect</h2>
              <p className="mb-2">We may collect the following types of information:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Personal Information: Name, email address, phone number, and business details when you contact us or fill out forms.</li>
                <li>Technical Information: IP address, browser type, and usage data collected via cookies or analytics tools.</li>
                <li>Client Data: Business operations data shared with us to deliver AI services.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">2. How We Use Your Information</h2>
              <p className="mb-2">We use the information we collect for the following purposes:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Providing and improving our services.</li>
                <li>Communicating with you regarding services, support, and updates.</li>
                <li>Personalizing your experience and enhancing our website performance.</li>
                <li>Complying with legal obligations.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">3. Data Sharing and Security</h2>
              <p className="mb-2">We do not sell or rent your personal data to third parties. We may share your information in the following cases:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Service Providers: Trusted partners assisting with service delivery.</li>
                <li>Legal Requirements: To comply with applicable laws or respond to lawful requests.</li>
              </ul>
              <p className="mt-2">We implement appropriate security measures to protect your data from unauthorized access, alteration, or loss.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">4. Cookies and Tracking</h2>
              <p>
                We use cookies and tracking technologies to improve user experience and analyze website traffic. 
                You can adjust your browser settings to block cookies or notify you when cookies are being used.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">5. Your Rights and Choices</h2>
              <p className="mb-2">You have the right to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Access, correct, or delete your personal information.</li>
                <li>Opt out of receiving marketing communications.</li>
                <li>Request a copy of the data we store about you.</li>
              </ul>
              <p className="mt-2">To exercise these rights, contact us at dubcityaisolutions@gmail.com.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">6. Third-Party Links</h2>
              <p>
                Our website may contain links to third-party sites. We are not responsible for the privacy practices of those sites. 
                We recommend reviewing their privacy policies before sharing any information.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">7. Policy Updates</h2>
              <p>
                We may update this privacy policy from time to time. Changes will be posted on this page, 
                and significant updates will be communicated via email or site notifications.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">8. Contact Us</h2>
              <p>If you have questions or concerns about this policy, please reach out to us:</p>
              <div className="mt-2">
                <p>DubCity AI Solutions</p>
                <p>Email: dubcityaisolutions@gmail.com</p>
                <p>Phone: 0221299230</p>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
